export default "__VITE_ASSET__DSz8MbQB__"